module.exports = __webpack_public_path__ + "img/xmasParty3.6419b078.jpg";